import {
  jb_checkbox_css_default
} from "./chunk.RJME6IOV.js";
import {
  l
} from "./chunk.VGR3SD7Z.js";
import {
  JbAnchor
} from "./chunk.DQC5CLKH.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  o
} from "./chunk.DJ2G5F2M.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  FormElement
} from "./chunk.TQSPBGH7.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-checkbox/jb-checkbox.ts
var JbCheckbox = class extends Initiable(FormElement(i)) {
  constructor() {
    super(...arguments);
    this.checked = false;
  }
  async updated(_changedProperties) {
    super.updated(_changedProperties);
    if (_changedProperties.has("label")) {
      await this.updateComplete;
      this._adjustLabelPaddingOnLineBreak();
    }
    this.renderRoot.querySelectorAll("a").forEach((element) => {
      if (element.getAttribute("href") === "#") return;
      const newAnchor = new JbAnchor().init({
        props: {
          link: {
            href: element.href,
            target: element.getAttribute("target") || void 0,
            data: {
              type: this._classifyLink(element)
            }
          }
        },
        innerHTML: element.innerHTML
      });
      element.replaceWith(newAnchor);
    });
  }
  appendFormData(formDataEvent) {
    formDataEvent.formData.append(this.name, this.checkbox.checked ? "1" : "");
  }
  async firstUpdated() {
    const resizeObserver = new ResizeObserver(() => {
      this._adjustLabelPaddingOnLineBreak();
    });
    await this.updateComplete;
    const targetElement = this.renderRoot.querySelector("label");
    resizeObserver.observe(targetElement, {});
  }
  isChecked() {
    return !!this.checkbox.checked;
  }
  // The stored form data holds the checked state, not a form value like for the other fields.
  populateValue() {
    if (!this.frontendRenderingIdentifier) return;
    const storedData = JSON.parse(localStorage.getItem("savedFormData") ?? "{}");
    if (this.frontendRenderingIdentifier in storedData) {
      this.checked = storedData[this.frontendRenderingIdentifier] === "true";
    }
  }
  validate() {
    const valid = this.requiredText ? this.checkbox.checked : true;
    this.showError = !valid;
    return valid;
  }
  _adjustLabelPaddingOnLineBreak() {
    try {
      const singleLineHeight = 20;
      if (this.labelElement && this.labelContent && this.labelContent.offsetHeight > singleLineHeight) {
        this.labelElement.classList.add("multiple-lines");
      } else {
        this.labelElement.classList.remove("multiple-lines");
      }
    } catch (e3) {
    }
  }
  _classifyLink(element) {
    const raw = element.getAttribute("href") ?? "";
    if (raw.startsWith("mailto:")) return "mail";
    if (raw.startsWith("#")) return "in-page";
    try {
      const url = new URL(element.href);
      return url.origin === window.location.origin ? "internal" : "external";
    } catch {
      return "internal";
    }
  }
  _handleInputChange(e3) {
    this.value = e3.target.value;
    this.checked = e3.target.checked;
    if (this.frontendRenderingIdentifier) {
      let storedData = localStorage.getItem("savedFormData");
      if (storedData !== null) {
        storedData = JSON.parse(storedData);
      } else {
        storedData = {};
      }
      storedData[this.frontendRenderingIdentifier] = this.checkbox.checked.toString();
      localStorage.setItem("savedFormData", JSON.stringify(storedData));
    }
  }
  _handleKeyDown(e3) {
    if (e3.code === "Space" || e3.code === "Enter") {
      e3.target.click();
      e3.preventDefault();
    }
  }
  // Render error block only, if there is an error to be shown
  _renderErrorMessage() {
    if (!this.name || !(this.errorText || this.showError)) return A;
    return b`<div id="${this.name}_error">
      ${this.errorText ? b` <p class="error-msg">${this.errorText}</p> ` : A}
      ${this.showError ? b` <p class="error-msg">${this.requiredText}</p> ` : A}
    </div>`;
  }
  render() {
    return b`
      <div
        class=${e2({
      error: this.showError || !!this.errorText,
      "has-after-checkbox-text": this.afterCheckboxText || !!this.afterCheckboxText,
      "has-before-checkbox-text": this.beforeCheckboxText || !!this.beforeCheckboxText,
      white: !!this.isWhite
    })}
      >
        ${this.beforeCheckboxText ? o(`
                <p class="before-checkbox-text">
                  ${this.beforeCheckboxText}
                </p> `) : A}
        <label
          tabindex="0"
          @keydown=${this._handleKeyDown}
        >
          <input
            tabindex="-1"
            class="sr-only"
            @input=${this._handleInputChange}
            type="checkbox"
            name="${this.name}"
            .value=${typeof this.value === "string" ? this.value : ""}
            ?required=${!!this.requiredText}
            ?disabled=${this.disabled}
            .checked=${l(this.checked)}
            aria-errormessage=${this.errorText || this.showError ? `${this.name}_error` : A}
            aria-invalid="${this.errorText || this.showError ? "true" : "false"}"
            aria-checked="${this.checked ? "true" : "false"}"
            aria-labelledby="checkboxlabel"
          />
          <span
            id="checkboxlabel"
            aria-hidden="true"
            >${o(this.label)}${this.requiredText ? " *" : A}</span
          >
        </label>
        ${this.afterCheckboxText ? o(`
              <p class="after-checkbox-text">
                ${this.afterCheckboxText}
              </p>
          `) : A}
        ${this._renderErrorMessage()}
      </div>
    `;
  }
};
JbCheckbox.styles = [reset_css_default, jb_checkbox_css_default];
JbCheckbox.shadowRootOptions = { ...i.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n()
], JbCheckbox.prototype, "afterCheckboxText", 2);
__decorateClass([
  n()
], JbCheckbox.prototype, "beforeCheckboxText", 2);
__decorateClass([
  e("input")
], JbCheckbox.prototype, "checkbox", 2);
__decorateClass([
  n({ type: Boolean })
], JbCheckbox.prototype, "checked", 2);
__decorateClass([
  n({ type: Boolean })
], JbCheckbox.prototype, "isWhite", 2);
__decorateClass([
  n()
], JbCheckbox.prototype, "label", 2);
__decorateClass([
  e("label span")
], JbCheckbox.prototype, "labelContent", 2);
__decorateClass([
  e("label")
], JbCheckbox.prototype, "labelElement", 2);
JbCheckbox = __decorateClass([
  customElement("jb-checkbox")
], JbCheckbox);

export {
  JbCheckbox
};
